import { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import useLocale from './useLocale';
import { UserLang } from '@constants/common';

function useInsuranceCheckerData() {
    const [insuranceData, setInsuranceData] = useState([]);
    const { currentLanguage } = useLocale();

    const gatsbyRepoData = useStaticQuery(graphql`
        query {
            aepsyApiDe {
                insuranceCompanies(input: { name: null }) {
                    id
                    name
                    companyPhoneNumber
                    supportEmail
                    requireDoctorNote
                    specialNote
                    supportPageUrl
                    callServiceHours
                    coachingCovered
                    packages {
                        id
                        value
                        name
                        description
                        maxAmount
                        discountType
                    }
                }
            }
            aepsyApiEn {
                insuranceCompanies(input: { name: null }) {
                    id
                    name
                    companyPhoneNumber
                    supportEmail
                    requireDoctorNote
                    specialNote
                    supportPageUrl
                    callServiceHours
                    coachingCovered
                    packages {
                        id
                        value
                        name
                        description
                        maxAmount
                        discountType
                    }
                }
            }
            aepsyApiFr {
                insuranceCompanies(input: { name: null }) {
                    id
                    name
                    companyPhoneNumber
                    supportEmail
                    requireDoctorNote
                    specialNote
                    supportPageUrl
                    callServiceHours
                    coachingCovered
                    packages {
                        id
                        value
                        name
                        description
                        maxAmount
                        discountType
                    }
                }
            }
            aepsyApiIt {
                insuranceCompanies(input: { name: null }) {
                    id
                    name
                    companyPhoneNumber
                    supportEmail
                    requireDoctorNote
                    specialNote
                    supportPageUrl
                    callServiceHours
                    coachingCovered
                    packages {
                        id
                        value
                        name
                        description
                        maxAmount
                        discountType
                    }
                }
            }
        }
    `);

    const getDataByLang = () => {
        switch (currentLanguage) {
            case UserLang.English:
                return gatsbyRepoData.aepsyApiEn.insuranceCompanies;
            case UserLang.Italian:
                return gatsbyRepoData.aepsyApiIt.insuranceCompanies;
            case UserLang.French:
                return gatsbyRepoData.aepsyApiFr.insuranceCompanies;
            case UserLang.German:
            default:
                return gatsbyRepoData.aepsyApiDe.insuranceCompanies;
        }
    };

    useEffect(() => {
        const data = getDataByLang();
        setInsuranceData(data);
    }, [gatsbyRepoData]);

    return { insuranceData };
}

export default useInsuranceCheckerData;
